import { z } from 'zod'
import { DateOrStringSchema } from './common'

export const TrainingSkillItemCodeSchema = z
  .string()
  .trim()
  .min(1, { message: '項目コードを入力してください。' })
  .max(50, { message: '項目コードは50文字以内で入力してください。' })
  .regex(/^[A-Za-z0-9_-]+$/, {
    message: '項目コードは半角英数字・ハイフン・アンダースコアで入力してください。',
  })

const categorySchema = z
  .string()
  .trim()
  .min(1, { message: '大項目を入力してください。' })
  .max(200, { message: '大項目は200文字以内で入力してください。' })

const labelSchema = z
  .string()
  .trim()
  .min(1, { message: '具体項目を入力してください。' })
  .max(500, { message: '具体項目は500文字以内で入力してください。' })

const sortOrderSchema = z.number().int().min(0)

export const CreateTrainingSkillItemSchema = z.object({
  code: TrainingSkillItemCodeSchema,
  category: categorySchema,
  label: labelSchema,
  sortOrder: sortOrderSchema.optional(),
})

// 項目コードは集計の同一性キーのため更新させない
export const UpdateTrainingSkillItemSchema = z
  .object({
    category: categorySchema,
    label: labelSchema,
    sortOrder: sortOrderSchema,
    isActive: z.boolean(),
  })
  .partial()

export type CreateTrainingSkillItemInput = z.infer<typeof CreateTrainingSkillItemSchema>
export type UpdateTrainingSkillItemInput = z.infer<typeof UpdateTrainingSkillItemSchema>

// ─── レスポンス ───────────────────────────────────────────

export const TrainingSkillItemResponseSchema = z.object({
  id: z.string(),
  trainingId: z.string(),
  code: z.string(),
  category: z.string(),
  label: z.string(),
  sortOrder: z.number(),
  isActive: z.boolean(),
  createdAt: DateOrStringSchema,
  updatedAt: DateOrStringSchema,
})

export const TrainingSkillItemImportResultSchema = z.object({
  imported: z.boolean(),
  created: z.number(),
  updated: z.number(),
  deactivated: z.number(),
  errors: z.array(z.object({ row: z.number(), message: z.string() })),
})

export type TrainingSkillItemResponse = z.infer<typeof TrainingSkillItemResponseSchema>
export type TrainingSkillItemImportResult = z.infer<typeof TrainingSkillItemImportResultSchema>
